// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmptyCart_wrapper__CKruV"};